<template>
  <transition name="fade">
    <component
      :is="layout"
      v-if="fetched">
      <transition name="switch">
        <router-view :key="$route.fullPath" />
      </transition>
    </component>
  </transition>
</template>

<script>
import FormUtils from './utils/FormUtils.js';
import SanitizeUtils from './utils/SanitizeUtils.js';
import Vue from 'vue';

export default {
  data () {
    return {
      fetched: false,
      user: null,
      loadUserError: false
    }
  },
  computed: {
    layout () {
      if (!this.$route.meta) {
        return 'default-layout';
      }

      return `${this.$route.meta.layout || 'default'}-layout`;
    },
  },
  beforeCreate () {
    let self = this;
    window.crmApp = {};

    window.crmApp = {
      permissionsAvailable () {
        return self.$store.state && self.$store.state.user && self.$store.state.user.permissions;
      },
      hasPermissions (permissionName) {
        return self.$store.state.user.permissions && self.$store.state.user.permissions[permissionName];
      }
    };
  },
  mounted () {
    if (!SanitizeUtils.getToken()) {
      this.fetched = true;
      return;
    }

    FormUtils.loadAdditionalData(this, {
      endpoint: '/auth/me',
      outputKey: 'user',
      errorKey: 'loadUserError',
      successAction: (response) => {
        this.fetched = true;
        this.$store.commit('setUserID', response.id);
        this.$store.commit('setUserEmail', response.email);
        this.$store.commit('setUserType', response.type);
        this.$store.commit('setUserPermissions', response.permissions);
      }
    });

    this.autoRefreshToken();
  },
  methods: {
    refreshToken () {
      FormUtils.submitInBackground(this, {
        endpoint: '/auth/generate-token',
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during refreshing API access. Please reload the page.',
        successAction: (data) => {
          window.localStorage.setItem('token', data.access_token);
          window.localStorage.setItem('last-token-refresh', +new Date());
          Vue.prototype.$http.defaults.headers.Authorization = 'Bearer ' + SanitizeUtils.getToken();
        }
      });
    },
    autoRefreshToken () {
      setTimeout(() => {
        if (window.localStorage.getItem('token')) {
          let lastRefresh = parseInt(window.localStorage.getItem('last-token-refresh'), 10);

          if (+new Date() - lastRefresh > 30 * 60 * 1000) {
            this.refreshToken();
          }
        }

        this.autoRefreshToken();
      }, 1 * 60 * 1000);
    }
  }
};
</script>

<style lang="scss">
@import './assets/scss/custom-elements.scss';

.switch-enter-to,
.switch-leave-to {
  transition: opacity .25s ease-out;
}

.switch-enter,
.switch-leave-to {
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transform: none;
  width: 100%;
}
</style>
